import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IEmployeeBusinessDetailsRequest } from '../models/bi-update.model';

export const biUpdateBusinessDetailsFeatureKey = 'biUpdateBusinessDetails';

export interface UpdateBusinessDetailsState {
  loadUpdateBusinessDetails: IEmployeeBusinessDetailsRequest;
  loadUpdateBusinessDetailsResponse: string;
  loadUpdateBusinessDetailsFailure: Error | any;
}

export const initialState: UpdateBusinessDetailsState = {
  loadUpdateBusinessDetails: undefined,
  loadUpdateBusinessDetailsResponse: undefined,
  loadUpdateBusinessDetailsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBiUpdateBusinessDetails, (state, action) => ({
    ...state,
    loadUpdateBusinessDetails: action.model
  })),
  on(actions.loadBiUpdateBusinessDetailsSuccess, (state, action) => ({
    ...state,
    loadUpdateBusinessDetailsResponse: action.response
  })),
  on(actions.loadBiUpdateBusinessDetailsFailure, (state, action) => ({
    ...state,
    loadUpdateBusinessDetails: action.error
  }))
);
